import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import { Grid, GridItem } from "../../../components/Grid";
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  TextInput,
  NumberInput,
  Dropdown,
  MessageBox,
  UpdateButton,
  ResetButton,
  Legend,
  Switch,
  PasswordInput,
} from "../../../components/FormElements";
import API from "../../../api";
import { API_RESPONSE_TYPES, PERMISSION_TYPES } from "../../../constants";
import { getReturnUrl } from "../../../utils";
import {
  StyledCallbackUrl,
  StyledSwitchContainer,
} from "../../../components/Styled";

const UsersUpdate = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [firmTypes, setFirmTypes] = useState([]);

  // User Details
  const [fullName, setFullName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberVerificationStatus, setMobileNumberVerificationStatus] =
    useState("Verified");
  const [userStatus, setUserStatus] = useState("Active");
  const [tempUserStatus, setTempUserStatus] = useState("Active");

  // Wallet Settings
  const [buyerWalletCap, setBuyerWalletCap] = useState("");
  const [withdrawStatus, setWithdrawStatus] = useState("Active");
  const [autoRedeemStatus, setAutoRedeemStatus] = useState("Yes");
  const [canSwitchFunds, setCanSwitchFunds] = useState("Active");
  const [autoWalletTransferStatus, setAutoWalletTransferStatus] =
    useState("No");
  const [redeemBlockPercentage, setRedeemBlockPercentage] = useState("");
  const [topupStatus, setTopupStatus] = useState("Active");
  const [autoWalletTransferAmount, setAutoWalletTransferAmount] = useState("");

  // Business Details
  const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("");
  const [turnover, setTurnover] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pincode, setPincode] = useState("");

  // KYC Details
  const [panNumber, setPanNumber] = useState("");
  const [panName, setPanName] = useState("");
  const [panStatus, setPanStatus] = useState("Active");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [aadhaarName, setAadhaarName] = useState("");
  const [aadhaarStatus, setAadhaarStatus] = useState("Active");
  const [gstNumber, setGstNumber] = useState("");
  const [gstName, setGstName] = useState("");
  const [gstStatus, setGstStatus] = useState("Active");
  const [kycStatus, setKycStatus] = useState("Active");
  const [esignDocNumber, setEsignDocNumber] = useState("");
  const [esignDate, setEsignDate] = useState("");
  const [esignStatus, setEsignStatus] = useState("No");

  // Alert Settings
  const [alertNumber, setAlertNumber] = useState("");
  const [email, setEmail] = useState("");
  const [alertType, setAlertType] = useState("");
  const [lowBalAlertStatus, setLowBalAlertStatus] = useState("Yes");

  // API Settings
  const [apiId, setApiId] = useState("");
  const [apiToken, setApiToken] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [callbackUrl, setCallbackUrl] = useState("");
  const [canEditApis, setCanEditApis] = useState("Inactive");
  const [complaintRatio, setComplaintRatio] = useState("100");

  // GST Settings
  const [isGSTSeller, setIsGSTSeller] = useState("No");
  const [gstType, setGstType] = useState("P2P");

  const [originalFormData, setOriginalFormData] = useState({});
  const { id } = useParams();

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const resetForm = () => {
    const {
      // User Details
      fullName,
      mobileNumber,
      mobileNumberVerificationStatus,
      userStatus,
      tempUserStatus,

      // Wallet Settings
      buyerWalletCap,
      withdrawStatus,
      autoRedeemStatus,
      canSwitchFunds,
      autoWalletTransferStatus,
      redeemBlockPercentage,
      topupStatus,
      autoWalletTransferAmount,

      // Business Details
      firmName,
      firmType,
      turnover,
      addressLine1,
      addressLine2,
      city,
      state,
      pincode,

      // KYC Details
      panNumber,
      panName,
      panStatus,
      aadhaarNumber,
      aadhaarName,
      aadhaarStatus,
      gstNumber,
      gstName,
      gstStatus,
      kycStatus,
      esignDocNumber,
      esignDate,
      esignStatus,

      // Alert Settings
      alertNumber,
      email,
      alertType,
      lowBalAlertStatus,

      // API Settings
      apiId,
      apiToken,
      ipAddress,
      callbackUrl,
      canEditApis,
      complaintRatio,

      // GST Settings
      isGSTSeller,
      gstType,
    } = originalFormData;

    // User Details
    setFullName(fullName);
    setMobileNumber(mobileNumber);
    setMobileNumberVerificationStatus(mobileNumberVerificationStatus);
    setUserStatus(userStatus);
    setTempUserStatus(tempUserStatus);

    // Wallet Settings
    setBuyerWalletCap(buyerWalletCap);
    setWithdrawStatus(withdrawStatus);
    setAutoRedeemStatus(autoRedeemStatus);
    setCanSwitchFunds(canSwitchFunds);
    setAutoWalletTransferStatus(autoWalletTransferStatus);
    setRedeemBlockPercentage(redeemBlockPercentage);
    setTopupStatus(topupStatus);
    setAutoWalletTransferAmount(autoWalletTransferAmount);

    // Business Details
    setFirmName(firmName);
    setFirmType(firmType);
    setTurnover(turnover);
    setAddressLine1(addressLine1);
    setAddressLine2(addressLine2);
    setCity(city);
    setState(state);
    setPincode(pincode);

    // KYC Details
    setPanNumber(panNumber);
    setPanName(panName);
    setPanStatus(panStatus);
    setAadhaarNumber(aadhaarNumber);
    setAadhaarName(aadhaarName);
    setAadhaarStatus(aadhaarStatus);
    setGstNumber(gstNumber);
    setGstName(gstName);
    setGstStatus(gstStatus);
    setKycStatus(kycStatus);
    setEsignDocNumber(esignDocNumber);
    setEsignDate(esignDate);
    setEsignStatus(esignStatus);

    // Alert Settings
    setAlertNumber(alertNumber);
    setEmail(email);
    setAlertType(alertType);
    setLowBalAlertStatus(lowBalAlertStatus);

    // API Settings
    setApiId(apiId);
    setApiToken(apiToken);
    setIpAddress(ipAddress);
    setCallbackUrl(callbackUrl);
    setCanEditApis(canEditApis);
    setComplaintRatio(complaintRatio);

    // GST Settings
    setIsGSTSeller(isGSTSeller);
    setGstType(gstType);
  };

  const readFirmTypes = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/meta/firm-types`)
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setFirmTypes(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const readData = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/accounts-management/users/${id}`)
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          const {
            // User Details
            fullName,
            mobileNumber,
            mobileNumberVerificationStatus,
            userStatus,
            tempUserStatus,

            // Wallet Settings
            buyerWalletCap,
            withdrawStatus,
            autoRedeemStatus,
            canSwitchFunds,
            autoWalletTransferStatus,
            redeemBlockPercentage,
            topupStatus,
            autoWalletTransferAmount,

            // Business Details
            firmName,
            firmType,
            turnover,
            addressLine1,
            addressLine2,
            city,
            state,
            pincode,

            // KYC Details
            panNumber,
            panName,
            panStatus,
            aadhaarNumber,
            aadhaarName,
            aadhaarStatus,
            gstNumber,
            gstName,
            gstStatus,
            kycStatus,
            esignDocNumber,
            esignDate,
            esignStatus,

            // Alert Settings
            alertNumber,
            email,
            alertType,
            lowBalAlertStatus,

            // API Settings
            apiId,
            apiToken,
            ipAddress,
            callbackUrl,
            canEditApis,
            complaintRatio,

            // GST Settings
            isGSTSeller,
            gstType,
          } = data[0];
          // User Details
          setFullName(fullName);
          setMobileNumber(mobileNumber);
          setMobileNumberVerificationStatus(mobileNumberVerificationStatus);
          setUserStatus(userStatus);
          setTempUserStatus(tempUserStatus);

          // Wallet Settings
          setBuyerWalletCap(buyerWalletCap);
          setWithdrawStatus(withdrawStatus);
          setAutoRedeemStatus(autoRedeemStatus);
          setCanSwitchFunds(canSwitchFunds);
          setAutoWalletTransferStatus(autoWalletTransferStatus);
          setRedeemBlockPercentage(redeemBlockPercentage);
          setTopupStatus(topupStatus);
          setAutoWalletTransferAmount(autoWalletTransferAmount);

          // Business Details
          setFirmName(firmName);
          setFirmType(firmType);
          setTurnover(turnover);
          setAddressLine1(addressLine1);
          setAddressLine2(addressLine2);
          setCity(city);
          setState(state);
          setPincode(pincode);

          // KYC Details
          setPanNumber(panNumber);
          setPanName(panName);
          setPanStatus(panStatus);
          setAadhaarNumber(aadhaarNumber);
          setAadhaarName(aadhaarName);
          setAadhaarStatus(aadhaarStatus);
          setGstNumber(gstNumber);
          setGstName(gstName);
          setGstStatus(gstStatus);
          setKycStatus(kycStatus);
          setEsignDocNumber(esignDocNumber);
          setEsignDate(esignDate);
          setEsignStatus(esignStatus);

          // Alert Settings
          setAlertNumber(alertNumber);
          setEmail(email);
          setAlertType(alertType);
          setLowBalAlertStatus(lowBalAlertStatus);

          // API Settings
          setApiId(apiId);
          setApiToken(apiToken);
          setIpAddress(ipAddress);
          setCallbackUrl(callbackUrl);
          setCanEditApis(canEditApis);
          setComplaintRatio(complaintRatio);

          // GST Settings
          setIsGSTSeller(isGSTSeller);
          setGstType(gstType);
          setOriginalFormData({
            // User Details
            fullName,
            mobileNumber,
            mobileNumberVerificationStatus,
            userStatus,
            tempUserStatus,

            // Wallet Settings
            buyerWalletCap,
            withdrawStatus,
            autoRedeemStatus,
            canSwitchFunds,
            autoWalletTransferStatus,
            redeemBlockPercentage,
            topupStatus,
            autoWalletTransferAmount,

            // Business Details
            firmName,
            firmType,
            turnover,
            addressLine1,
            addressLine2,
            city,
            state,
            pincode,

            // KYC Details
            panNumber,
            panName,
            panStatus,
            aadhaarNumber,
            aadhaarName,
            aadhaarStatus,
            gstNumber,
            gstName,
            gstStatus,
            kycStatus,
            esignDocNumber,
            esignDate,
            esignStatus,

            // Alert Settings
            alertNumber,
            email,
            alertType,
            lowBalAlertStatus,

            // API Settings
            apiId,
            apiToken,
            ipAddress,
            callbackUrl,
            canEditApis,
            complaintRatio,

            // GST Settings
            isGSTSeller,
            gstType,
          });
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    const formData = {
      // User Details
      fullName,
      mobileNumber,
      mobileNumberVerificationStatus,
      userStatus,
      tempUserStatus,

      // Wallet Settings
      buyerWalletCap,
      withdrawStatus,
      autoRedeemStatus,
      canSwitchFunds,
      autoWalletTransferStatus,
      redeemBlockPercentage,
      topupStatus,
      autoWalletTransferAmount,

      // Business Details
      firmName,
      firmType,
      turnover,
      addressLine1,
      addressLine2,
      city,
      state,
      pincode,

      // KYC Details
      panNumber,
      panName,
      panStatus,
      aadhaarNumber,
      aadhaarName,
      aadhaarStatus,
      gstNumber,
      gstName,
      gstStatus,
      kycStatus,
      esignDocNumber,
      esignDate,
      esignStatus,

      // Alert Settings
      alertNumber,
      email,
      alertType,
      lowBalAlertStatus,

      // API Settings
      apiId,
      apiToken,
      ipAddress,
      callbackUrl,
      canEditApis,
      complaintRatio,

      // GST Settings
      isGSTSeller,
      gstType,
    };
    API.put(`/accounts-management/users/${id}`, formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setOriginalFormData(formData);
          setTimeout(() => {
            resetResponseData();
            window.location.href = getReturnUrl(PERMISSION_TYPES.UPDATE);
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    readFirmTypes();
    readData();
  }, [readFirmTypes, readData]);

  const firmTypesOptions = [{ title: "-- SELECT FIRM TYPE --", value: "" }];

  firmTypes &&
    firmTypes?.length > 0 &&
    firmTypes?.forEach(({ id, type }) =>
      firmTypesOptions.push({
        title: type,
        value: id,
      })
    );

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          <Fieldset forLegend>
            <Legend>User Details</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>Full Name</Label>
                  <TextInput
                    value={fullName}
                    onChange={setFullName}
                    placeholder="Please enter full name"
                    maxLength={100}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Mobile Number</Label>
                  <NumberInput
                    value={mobileNumber}
                    onChange={setMobileNumber}
                    placeholder="Please enter mobile number"
                    maxLength={10}
                    disabled={isLoading}
                    pattern={`[0-9]*`}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Mobile Verification Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={mobileNumberVerificationStatus === "Verified"}
                      onChange={(value) => {
                        setMobileNumberVerificationStatus(
                          value ? "Verified" : "Pending"
                        );
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Login Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={tempUserStatus === "Active"}
                      onChange={(value) => {
                        setTempUserStatus(value ? "Active" : "Inactive");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Permanent Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={userStatus === "Active"}
                      onChange={(value) => {
                        setUserStatus(value ? "Active" : "Inactive");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          <Fieldset forLegend>
            <Legend>Wallet Settings</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>Buyer Wallet Cap</Label>
                  <NumberInput
                    value={buyerWalletCap}
                    onChange={setBuyerWalletCap}
                    placeholder="Please enter wallet cap"
                    maxLength={10}
                    pattern={`[0-9]*`}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Redeem Hold Percentage</Label>
                  <NumberInput
                    value={redeemBlockPercentage}
                    onChange={setRedeemBlockPercentage}
                    placeholder="Please enter redeem hold percentage"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Auto Switch Funds Amount</Label>
                  <NumberInput
                    value={autoWalletTransferAmount}
                    onChange={setAutoWalletTransferAmount}
                    placeholder="Please enter auto wallet transfer amount"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Wallet Topup</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={topupStatus === "Active"}
                      onChange={(value) => {
                        setTopupStatus(value ? "Active" : "Inactive");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Redeem Funds</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={withdrawStatus === "Active"}
                      onChange={(value) => {
                        setWithdrawStatus(value ? "Active" : "Inactive");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Auto Redeem</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={autoRedeemStatus === "Yes"}
                      onChange={(value) => {
                        setAutoRedeemStatus(value ? "Yes" : "No");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Switch Funds</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={canSwitchFunds === "Active"}
                      onChange={(value) => {
                        setCanSwitchFunds(value ? "Active" : "Inactive");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Auto Switch Funds</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={autoWalletTransferStatus === "Yes"}
                      onChange={(value) => {
                        setAutoWalletTransferStatus(value ? "Yes" : "No");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          <Fieldset forLegend>
            <Legend>Business Details</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>Company Name</Label>
                  <TextInput
                    value={firmName}
                    onChange={setFirmName}
                    placeholder="Please enter company name"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Company Type</Label>
                  <Dropdown
                    value={firmType}
                    onChange={setFirmType}
                    placeholder="Please select firm type"
                    disabled={isLoading}
                    options={firmTypesOptions}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Turnover</Label>
                  <NumberInput
                    value={turnover}
                    onChange={setTurnover}
                    placeholder="Please enter turnover"
                    maxLength={1000}
                    disabled={isLoading}
                    pattern={`[0-9]*`}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>Address Line 1</Label>
                  <TextInput
                    value={addressLine1}
                    onChange={setAddressLine1}
                    placeholder="Please enter address line 1"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Address Line 2</Label>
                  <TextInput
                    value={addressLine2}
                    onChange={setAddressLine2}
                    placeholder="Please enter address line 2"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>City</Label>
                  <TextInput
                    value={city}
                    onChange={setCity}
                    placeholder="Please enter city"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>State</Label>
                  <TextInput
                    value={state}
                    onChange={setState}
                    placeholder="Please enter state"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Pincode</Label>
                  <TextInput
                    value={pincode}
                    onChange={setPincode}
                    placeholder="Please enter pincode"
                    maxLength={8}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          <Fieldset forLegend>
            <Legend>KYC Details</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>PAN Number</Label>
                  <TextInput
                    value={panNumber}
                    onChange={setPanNumber}
                    placeholder="Please enter pan number"
                    maxLength={20}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Name on PAN</Label>
                  <TextInput
                    value={panName}
                    onChange={setPanName}
                    placeholder="Please enter name as per pan card"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>PAN Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={panStatus === "Verified"}
                      onChange={(value) => {
                        setPanStatus(value ? "Verified" : "Pending");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>Aadhaar Number</Label>
                  <TextInput
                    value={aadhaarNumber}
                    onChange={setAadhaarNumber}
                    placeholder="Please enter aadhaar number"
                    maxLength={20}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Name on Aadhaar</Label>
                  <TextInput
                    value={aadhaarName}
                    onChange={setAadhaarName}
                    placeholder="Please enter name as per aadhaar card"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Aadhaar Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={aadhaarStatus === "Verified"}
                      onChange={(value) => {
                        setAadhaarStatus(value ? "Verified" : "Pending");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>GST Number</Label>
                  <TextInput
                    value={gstNumber}
                    onChange={setGstNumber}
                    placeholder="Please enter GST number"
                    maxLength={100}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Name on GST</Label>
                  <TextInput
                    value={gstName}
                    onChange={setGstName}
                    placeholder="Please enter name as per GST"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>GST Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={gstStatus === "Verified"}
                      onChange={(value) => {
                        setGstStatus(value ? "Verified" : "Pending");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>eSign Doc Number</Label>
                  <TextInput
                    value={esignDocNumber}
                    onChange={setEsignDocNumber}
                    placeholder="Please enter esign doc number"
                    maxLength={100}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>eSign Date</Label>
                  <TextInput
                    type="date"
                    value={esignDate}
                    onChange={setEsignDate}
                    placeholder="Please select esign date"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>eSign Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={esignStatus === "Yes"}
                      onChange={(value) => {
                        setEsignStatus(value ? "Yes" : "No");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>eKYC Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={kycStatus === "Approved"}
                      onChange={(value) => {
                        setKycStatus(value ? "Approved" : "Pending");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          <Fieldset forLegend>
            <Legend>Alert Settings</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Whatsapp Alert Number</Label>
                  <NumberInput
                    value={alertNumber}
                    onChange={setAlertNumber}
                    placeholder="Please enter alert number"
                    maxLength={10}
                    disabled={isLoading}
                    pattern={`[0-9]*`}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Email</Label>
                  <TextInput
                    value={email}
                    onChange={setEmail}
                    placeholder="Please enter email"
                    maxLength={1000}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Alert Type</Label>
                  <Dropdown
                    value={alertType}
                    onChange={setAlertType}
                    placeholder="Please select alert type"
                    disabled={isLoading}
                    options={[
                      {
                        title: "-- SELECT ALERT TYPE --",
                        value: "",
                      },
                      {
                        title: "Whatsapp",
                        value: "Whatsapp",
                      },
                      {
                        title: "Email",
                        value: "Email",
                      },
                    ]}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Low Balance Alert</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={lowBalAlertStatus === "Yes"}
                      onChange={(value) => {
                        setLowBalAlertStatus(value ? "Yes" : "No");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          <Fieldset forLegend>
            <Legend>API Settings</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label required>API ID</Label>
                  <PasswordInput
                    placeholder="Your API ID"
                    value={apiId}
                    autoComplete="off"
                    disabled={true}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>API Token</Label>
                  <PasswordInput
                    placeholder="Your API Token"
                    value={apiToken}
                    autoComplete="off"
                    disabled={true}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label required>Server IP</Label>
                  <TextInput
                    placeholder="Please enter your server ip"
                    value={ipAddress}
                    onChange={setIpAddress}
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APIS Edit Status</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={canEditApis === "Active"}
                      onChange={(value) => {
                        setCanEditApis(value ? "Active" : "Inactive");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
            </Grid>
            <Fieldset>
              <Label required>Complaint Ratio</Label>
              <NumberInput
                value={complaintRatio}
                onChange={setComplaintRatio}
                placeholder="Please enter complaint ratio"
                disabled={isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Callback URL</Label>
              <TextInput
                placeholder="Please enter your callback url"
                value={callbackUrl}
                onChange={setCallbackUrl}
                disabled={isLoading}
              />
              <StyledCallbackUrl>
                {`Example : ${
                  callbackUrl
                    ? callbackUrl
                    : `https://www.yourdomain.com/recharge_callback`
                }?status=[TRANSACTION_STATUS]&txn_id=[TRANSACTION_ID]&operators_id=[OPERATOR_ID]&customer_account_number=[CUSTOMER_ACCOUNT_NUMBER]&customer_mobile=[CUSTOMER_MOBILE_NUMBER]&amount=[AMOUNT]&payment_time=[PAYMENT_TIME]&ref_number=[YOUR_REF_NUMBER]`}
              </StyledCallbackUrl>
            </Fieldset>
          </Fieldset>

          <Fieldset forLegend>
            <Legend>GST Settings</Legend>
            <Grid>
              <GridItem>
                <Fieldset>
                  <Label>Is GST Seller?</Label>
                  <StyledSwitchContainer>
                    <Switch
                      value={isGSTSeller === "Yes"}
                      onChange={(value) => {
                        setIsGSTSeller(value ? "Yes" : "No");
                      }}
                    />
                  </StyledSwitchContainer>
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>GST Type</Label>
                  <Dropdown
                    placeholder="Please select gst account type"
                    value={gstType}
                    onChange={setGstType}
                    options={[
                      {
                        title: "-- SELECT GST ACCOUNT TYPE --",
                        value: "",
                      },
                      {
                        title: "P2P",
                        value: "P2P",
                      },
                      {
                        title: "P2A",
                        value: "P2A",
                      },
                    ]}
                    disabled={isLoading || isGSTSeller !== "Yes"}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>

          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <UpdateButton disabled={isLoading} type="submit">
              Update
            </UpdateButton>
            <ResetButton disabled={isLoading} type="button" onClick={resetForm}>
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(UsersUpdate);
